import { memo, useCallback } from "react";
import { Pressable } from "react-native";
import { useUnistyles } from "react-native-unistyles";
import { View, Text, Card } from "@src/components";
import { Icon } from "@src/components/Icon";
import type { CameraSiteGroup } from "@src/features/cameras/utils/camera-group";

interface SiteCardProps {
  group: CameraSiteGroup;
  isSelected?: boolean;
  onPress: (siteId: string) => void;
}

export const SiteCard = memo(({ group, onPress }: SiteCardProps) => {
  const { theme } = useUnistyles();
  const handlePress = useCallback(() => {
    onPress(group.siteId);
  }, [onPress, group.siteId]);

  return (
    <Pressable onPress={handlePress}>
      <Card
        style={{
          width: 280,
          padding: theme.spacing["4xl"],
          gap: theme.spacing.xs,
        }}
      >
        <View flexDirection="row" alignItems="center" gap="xs">
          <Icon name="building" size={20} color={theme.colors.textMuted} />
          <Text textStyle="sm/medium">{group.siteName}</Text>
        </View>
        {group.siteSubtitle && (
          <Text textStyle="xs/regular" color="textMuted">
            {group.siteSubtitle}
          </Text>
        )}
        <Text textStyle="xs/regular" color="textMuted">
          {group.cameras.length} {group.cameras.length === 1 ? "camera" : "cameras"}
        </Text>
      </Card>
    </Pressable>
  );
});
